export default "__VITE_ASSET__B3sIR24p__"